
import { i18nText } from '@/locales';

    import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
    import { Component, Vue, Watch } from "vue-property-decorator";
    import { SimpleProxyForm } from "@/UI/components/Helpers/SimpleProxyForm";
    import { Col, Result, Row, Table } from "ant-design-vue";
    import { mixins } from "vue-class-component";
    import { VisitsGeneralMix } from "@/UI/mixins/Visits/VisitsGeneralMix";
    import { ClientsStore } from "@/store/modules/Clients";
    import { showNotificationSimple } from "@/UI/lib/messages";
    import { AsYouType } from "libphonenumber-js";
    import { AppStateStore } from "@/store/modules/appState";
    import { RouterNameEnum } from "@/router/router.types";
    import { getStudioId } from "@/UI/lib/state";
    import { receiptLines, receiptVisitId } from "@/UI/pages/visitsNew/Lib/money";
    import { VisitsStore } from "@/store/modules/Visits";
    import { getVisitData } from "@/UI/pages/visitsNew/Lib/support";

    @Component({
        components: {
            BaseDataForm,
            "a-col": Col,
            "a-row": Row,
            "a-result": Result,
            "a-table": Table,
        },
    })
    export default class PayForm extends mixins(SimpleProxyForm, VisitsGeneralMix) {
        receiptColumns = [
            { title: i18nText("Позиция"), dataIndex: 'name' },
            { title: i18nText("Кол-во"), dataIndex: 'quantity' },
            { title: i18nText("Цена, ₽"), dataIndex: 'price', scopedSlots: { customRender: 'money' } },
            { title: i18nText("Скидка, %"), dataIndex: 'discount' },
            { title: i18nText("Сумма, ₽"), dataIndex: 'amount', scopedSlots: { customRender: 'money' } },
        ];

        get receiptItems(): Array<Record<string, any>> {
            return receiptLines(this.visit?.basket);
        }
        get remaining(): number {
            return Math.max(0, Number(this.visit?.order?.sum || 0) - Number(this.visit?.order?.paid || 0));
        }
        get fullyPaid(): boolean {
            return Boolean(this.visit?.order?.paid_at) && this.remaining === 0;
        }
        money(value: number | string): string {
            return Number(value).toLocaleString(this.$i18n.locale === 'en' ? 'en-US' : 'ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
        @Watch("$store.state.appState.sendCancel", { immediate: false })
        async ButtonCancel(): Promise<void> {
            AppStateStore.setCancel(false);
            await Vue.router.push({
                name: RouterNameEnum.VisitsNewDate,
                params: { Date: String(Date.parse(this.visit.visit_dt.replace(' ', 'T'))), Studio: getStudioId(this) },
            });
        }

        phoneNum(data: string): string {
            return new AsYouType().input('+' + String(data).replace(/\D/g, '')).replace(/^\+/, '');
        }
        async created(): Promise<void> {
            this.formReady = false;
            try {
                const visitId = receiptVisitId(this.$route.params);
                await getVisitData(visitId, VisitsStore);
                if (!this.visit || Number(this.visit.id) !== visitId) {
                    throw new Error(i18nText("Визит не найден"));
                }
                await ClientsStore.fetchData({ filter: { id: this.visit.client_id } });
                this.formReady = true;
            } catch (e) {
                showNotificationSimple(i18nText("Ошибка"), i18nText("Не удалось загрузить результат оплаты"), 10);
            }
        }
    }
